import { Stack, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { RecognizedBodyStatus } from '@app-types/recognizedBody';
import { recognizedBodiesApi } from '@api';

const withIFrameAccess = 
  (Component: React.FC) =>
    ({ ...props }) => {
      const theme = useTheme();

      const [error, setError] = useState('');

      const recognizedBodyId = new URLSearchParams(window.location.search).get('external') || sessionStorage.getItem('iframeExternalId');
      const hostSiteDomain = window.location.ancestorOrigins?.[0];

      useEffect(() => {
        (async () => {
          if (!hostSiteDomain || hostSiteDomain.includes(process.env.REACT_APP_IFRAME_HOST_SITE_KONBEO_DOMAIN as string))
            return;

          if (!recognizedBodyId)
            return setError('Embedding website is not allowed');

          const { data: recognizedBody } = await recognizedBodiesApi.getOne(recognizedBodyId);

          // Both active and inactive recognized bodies may embed the iframe. An inactive body is only
          // excluded from automatic assignment later on (see CounselingRecognizedBody), the iframe itself keeps working.
          const isEmbeddingAllowed =
            [RecognizedBodyStatus.Active, RecognizedBodyStatus.Inactive].includes(recognizedBody?.status) &&
            recognizedBody?.approvedURLs.some((url) => hostSiteDomain.endsWith(url));

          if (!isEmbeddingAllowed) {
            sessionStorage.removeItem('iframeExternalId');
            return setError('Embedding website is not allowed');
          }

          sessionStorage.setItem('iframeExternalId', recognizedBodyId);
        })();
      }, []);

      if (error) {
        return (
          <Stack sx={{ 
            position: 'absolute', 
            inset: 0, 
            height: '100%', 
            width: '100%',  
            alignItems: 'center', 
            justifyContent: 'center', 
          }}>
            <Typography color={theme.palette.error.main}>{error}</Typography>
          </Stack>
        );
      }

      return <Component {...props} />;
    };

export default withIFrameAccess;
